import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import usePageTitle from "../../hooks/usePageTitle";
import { ROUTE_SECURITY_DOCUMENTS, ROUTE_WELCOME } from "../../routes/Routes";
import PutPostPatchFetch from "../../hooks/PutPostPatchFetch";
import ScrollView from 'devextreme-react/scroll-view';
import { BasicSecurityForm } from '../../components/BasicSecurity/BasicSecurityForm';
import { List } from 'devextreme-react/list';
import notify from "devextreme/ui/notify";
import ClosingAlert from "../../components/ClosingAlert";
import { DateBox } from "devextreme-react";
import BaseNotification from "../../components/BaseNotification/BaseNotification";
import { fileSizeConversion } from "../../util/FileSizeConversion";
import { BaseButton } from "../../components/BaseButton/BaseButton";
import 'devextreme/dist/css/dx.light.css';
import FiscalYearDropdown from '../../FyCostEstimates/AddSecurityCost/FiscalYearDropdown';
import './AddTemplate.scss';
import { ValidationMessageItem } from "./ValidationMessageItem/ValidationMessageItem";

const SecurityDocumentsTransfer = () => {
    const { title } = ROUTE_SECURITY_DOCUMENTS;
    usePageTitle(title);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fiscalYear, setFiscalYear] = useState(null);
    const [data, setData] = useState(null);    
    const [successMessage, setSuccessMessage] = useState('');
    const [validationMessage, setValidationMessage] = useState([]);
    const [errorMessage, setErrorMessage] = useState(false);
    const [alertVisible, setAlertVisible] = useState(false);
    const [notification, setNotification] = useState({
        message: '',
        type: undefined,
        visible: false
    });

    const navigate = useNavigate();
    const navigateToRoute = () => navigate(ROUTE_WELCOME.withSlash);
    const fileInputRef = useRef(null);
    
    const newBasicSecurityTemplate = {
        Id: 0,
        BillDate: null,
        UploadFile: null,
    }

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setData(newBasicSecurityTemplate);
        console.log(data)
    };

    // A very large number of milliseconds to prevent the toast from disappearing automatically.
    const infiniteDisplayTime = 2147483647;
    usePageTitle(title);


    const handleFileUpload = (event) => {
        const files = Array.from(event.target.files);
        const { size } = event.target.files[0];
        const maxFileSize = 25000000; // 25 MB

        if (size && size >= maxFileSize) {
            setNotification({
                visible: true,
                message: `The file you have selected is too large in size. Please choose a .csv file with a size that is under 25 MB.`,
                type: 'error'
            });
        };

        if (size && size < maxFileSize) {
            setNotification({
                visible: true,
                message: `File selection successful.`,
                type: 'success'
            });
            setSelectedFiles(prevFiles => [...prevFiles, ...files]);
        };

        fileInputRef.current.value = "";
    };

    const RemoveSelectedFiles = async (event) => {
        event.preventDefault();

        setNotification({
            message: '',
            type: undefined,
            visible: false
        });

        selectedFiles.length = 0;
        setSelectedFiles(prevFiles => [...prevFiles, ...selectedFiles]);

    }
    const handleSubmit = async (event) => {
        setNotification({
            message: '',
            type: undefined,
            visible: false
        });

        event.preventDefault();
        const formData = new FormData();

        for (let i = 0; i < selectedFiles.length; i++) {
            formData.append("Files", selectedFiles[i])
        };


        try {
            const { Errors, Message, Success } =
                await PutPostPatchFetch(
                    `/v1/BasicSecurity/UploadSecurityDocuments?billingDate=${String(fiscalYear)}`,
                    'POST',
                    formData,
                    'multipart/form-data'
                );

            if (Success) {
                setNotification({
                    visible: true,
                    message: `Files submitted successfully.`,
                    type: 'success'
                });
            };

            if (!Success) {
                setNotification({
                    visible: true,
                    message: Errors[0],
                    type: 'error'
                });
            };
        } catch (error) {
            console.error('Error: ', error);
        }

    };

    // const handleCloseAlert = () => {
    //     setAlertVisible(false);
    // };

    return (
        <div>
            <h1> {title} </h1>
            <ScrollView className='view-wrapper-scroll'>
                <div className='view-wrapper view-wrapper-contact-details'>
                    <div className='panels'>
                        <BasicSecurityForm
                            data={data}
                            fileExtensions={['.docx', '.pdf']}
                            postPath='/v1/BasicSecurity/UploadSecurityDocuments?billingDate='
                            backPath={ROUTE_SECURITY_DOCUMENTS.withSlash}
                            isLoading={false}
                            isEditing={true}
                        />
                    </div>
                </div>
            </ScrollView>

            {/*             <div className="block block__div--wrapper">
            <FiscalYearDropdown 
                    enableSearch={true}
                    inputAttribute={{ "aria-label": "fiscal year select" }}
                    label={"Fiscal Year"}
                    optionUpdatedByUser={({ selectedItem }) => setFiscalYear(selectedItem)}
                    value={fiscalYear}
                    isVisible={true}
                />
            </div>
            <div className="block block__div--wrapper">
                <BaseButton
                    label={"Select file"}
                    onClick={() => document.getElementById('file-upload-input').click()}
                    variant={"outlined"}
                />
                <input
                    accept=".pdf"
                    id="file-upload-input"
                    onChange={handleFileUpload}
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    type="file"
                />
                <BaseButton
                    aria-disabled={selectedFiles.length === 0}
                    disabled={selectedFiles.length === 0}
                    onClick={handleSubmit}
                    variant={"outlined"}
                    label={"Submit"}
                />
            </div>
            <div className="block">
                <div className={
                    selectedFiles.length === 0 ? 
                    "block__unscrollable-container" 
                    : 
                    "block__scrollable-container"
                    }>
                    {
                        !selectedFiles.length === 0 && 
                        <div className="inline__empty-list">                            
                            <span>
                                No File Selected
                            </span>
                        </div>
                    }
                    {
                        selectedFiles.length > 0 &&
                        <ul className="block__unordered-list">
                            {
                                selectedFiles.map(({
                                    index,
                                    name, 
                                    size
                                }) => {
                                    const formattedSize = fileSizeConversion(size);
                                    return (
                                        //TODO: Using name instead of index gets rid of error, but need to find a better indexing method
                                        <li key={name} className="inline__list-item">
                                            <span className="inline__span--file-name">
                                                {name} 
                                            </span>
                                            <span className="inline__span--file-size">
                                                {formattedSize}
                                            </span>
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    }
                </div> 
            </div>
               
            <div className="block block__div--wrapper">
                <BaseButton
                    label={"cancel"}
                    onClick={RemoveSelectedFiles}
                    variant={"outlined"}
                />
            </div> */}

            {/*             {
                errorMessage &&
                <div className="list-container">
                    <>
                        <h2 className="h2--validation-errors"> Validation Errors </h2>
                        <List
                            dataSource={validationMessage}
                            height="100%"
                            itemRender={ValidationMessageItem}
                        />
                    </>
                </div>
            }  */}

            {/*             <BaseNotification 
                message={notification.message}
                ref={useRef(null)}
                setter={() => setNotification(() => (
                    { 
                        isVisible: false,
                        message: '',
                        type: undefined
                    }
                ))}
                type={notification.type}
                visible={notification.visible}
            /> */}
        </div>

    );
};

export default SecurityDocumentsTransfer;
